/** @type {any} */
// @ts-ignore
const gsap = window.gsap || {};
/** @type {any} */
// @ts-ignore
const ScrollTrigger = window.ScrollTrigger || {};

document.addEventListener('DOMContentLoaded', () => {
    const sectionContainers = document.querySelectorAll('[data-floating-canvas]');

    function initAnimations() {
        if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
            setTimeout(initAnimations, 100);
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        sectionContainers.forEach(canvas => {
            const section = canvas.closest('.section-floating-images');
            const wrapBg = section.querySelector('.floating-images');
            const track = canvas.querySelector('[data-floating-track]');
            const scatter = canvas.querySelector('[data-floating-scatter]');
            if (!scatter) return;

            const cards = Array.from(scatter.querySelectorAll('[data-floating-card]'));

            if (!cards.length) return;

            // Prevent duplicate triggers if Shopify theme customizer reloads the script or F5 restores scroll awkwardly
            ScrollTrigger.getAll().forEach(t => {
                if (t.vars.trigger === wrapBg || t.vars.trigger === section) t.kill();
            });

            // 1. Grid Placement to avoid overlapping
            const isMobile = window.innerWidth < 1000;
            const cols = isMobile ? 2 : 3;

            // Scale factor for screens >= 1920px (px / 1920 * viewportWidth)
            const vw = window.innerWidth;
            const scale = (!isMobile && vw >= 1920) ? vw / 1920 : 1;
            // Helper: converts px to vw string on large screens (px / 1920 * 100)
            const useVw = !isMobile && vw >= 1920;
            const toUnit = (px) => useVw ? `${(px / 1920 * 100).toFixed(3)}vw` : `${px}px`;

            // Get actual height rendered by CSS (respecting the 700px max height cap)
            const viewHeight = wrapBg.offsetHeight || 700;

            // We need to space images far apart strictly. Instead of random accumulations,
            // we will divide the total track height into explicit "rows".
            const numRows = Math.ceil(cards.length / cols);
            // Drastically increased base gap. On desktop, start each row at least 350px apart.
            const rowHeight = isMobile ? 300 : 450 * scale;

            // Map specific x-positions correctly to create zigzag/staggered feel
            const xPositions = isMobile ? [20, 80] : [15, 50, 85];

            // Calculate total necessary container height before doing placements
            const totalTrackHeight = (numRows * rowHeight) + (viewHeight * 0.5);

            // On mobile, group cards into depth buckets instead of individual parallax
            const mobileBuckets = { slow: [], fast: [] };

            cards.forEach((card, index) => {
                const colIndex = index % cols;
                const rowIndex = Math.floor(index / cols);

                // 1. Sizing: Mixed aspect ratios (Landscape and Portrait) to ensure distinct rectangles
                // Limits: max-width 302px, max-height 276px
                const minWidth = isMobile ? 240 : 302;
                const maxWidth = isMobile ? 240 : 302;

                let randomWidth, randomHeight;
                const isPortrait = Math.random() > 0.5;

                if (isPortrait) {
                    // Tall rectangles (Portrait)
                    randomHeight = gsap.utils.random(isMobile ? 160 : 200, isMobile ? 200 : 276);
                    randomWidth = randomHeight * gsap.utils.random(0.65, 0.85); // Width is 65-85% of height
                } else {
                    // Wide rectangles (Landscape)
                    randomWidth = gsap.utils.random(isMobile ? 180 : 230, maxWidth);
                    randomHeight = randomWidth * gsap.utils.random(0.55, 0.75); // Height is 55-75% of width
                }

                // Absolute cap per requested restrictions
                randomHeight = Math.min(randomHeight, isMobile ? 200 : 276);

                // Scale Ratio to calculate depth features (0 = furthest, 1 = closest)
                let sizeRatio = (randomWidth - minWidth) / (maxWidth - minWidth);
                sizeRatio = Math.max(0, Math.min(1, sizeRatio)); // Keep safe 0-1 bounds

                // 2. Exact Grid Positioning with slight wobble (not full random overlaps)
                const laneCenter = xPositions[colIndex];
                const horizontalVariance = gsap.utils.random(-8, 8); // subtle wobble
                const leftPercent = Math.max(10, Math.min(90, laneCenter + horizontalVariance));

                // Vertically space them into their explicit row slots.
                // Add staggered elevation on columns to avoid perfect horizontal rows.
                const staggerColOffset = isMobile ? (colIndex * 100) : (colIndex === 1 ? 250 * scale : colIndex === 2 ? 100 * scale : 0);

                // Final Y position: Base offset + Row offset + Column offset + slight vertical wobble
                const baseDrop = viewHeight * 0.2;
                const verticalWobble = gsap.utils.random(-50 * scale, 50 * scale);
                const topPx = baseDrop + (rowIndex * rowHeight) + staggerColOffset + verticalWobble;

                // 3. Depth-based styling: smaller = background, larger = foreground
                const opacityAmount = 0.8 + (sizeRatio * 0.2); // min 0.8 to 1
                const zIndex = Math.floor(sizeRatio * 100);

                // Apply explicit sizing and layout to the card container
                gsap.set(card, {
                    left: `${leftPercent}%`,
                    top: `${topPx}px`,
                    xPercent: -50,
                    yPercent: -50,
                    width: toUnit(randomWidth),
                    zIndex: zIndex,
                    opacity: opacityAmount
                });

                // Apply explicit height to the image wrapper
                const imageWrap = card.querySelector('.floating-images__image-wrap');
                if (imageWrap) {
                    gsap.set(imageWrap, { height: toUnit(randomHeight) });
                }

                // 4. Assign parallax — 2 depth buckets for fewer tweens
                if (sizeRatio > 0.5) {
                    mobileBuckets.fast.push(card);
                } else {
                    mobileBuckets.slow.push(card);
                }
            });

            // Set final track height dynamically so we don't run out of space
            gsap.set(scatter, { height: totalTrackHeight });

            const startY = viewHeight;
            // Finish pinning exactly when the last bottom image crosses the active viewport base
            const paddingBottom = 150 * scale;
            const endY = (viewHeight - paddingBottom) - totalTrackHeight;
            const totalTravelDistance = startY - endY;

            // Lengthen the pinned scroll distance so it takes significantly more trackpad/wheel
            // movement to push the images up, moving them slower on screen.
            const scrollPinDistance = totalTravelDistance * 0.85;

            // SINGLE MASTER TIMELINE
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: wrapBg,
                    start: "center center",
                    end: `+=${scrollPinDistance}`,
                    pin: true,
                    scrub: isMobile ? 0.3 : 1,
                    invalidateOnRefresh: true
                }
            });

            // Heading text appears FIRST
            const headingContainer = section.querySelector('.floating-images__heading-container');
            if (headingContainer) {
                gsap.set(headingContainer, { yPercent: 0 });
                tl.fromTo(headingContainer,
                    { y: `${150 * scale}px`, opacity: 0 },
                    { y: "0px", opacity: 1, ease: "power2.out", duration: scrollPinDistance * 0.2 },
                    0
                );
            }

            // Main Track Scrub
            gsap.set(track, { y: startY });
            tl.fromTo(track,
                { y: startY },
                { y: endY, ease: "none", duration: scrollPinDistance },
                0
            );

            // Parallax Scrub: 2 depth buckets (slow/fast) instead of per-card tweens
            const slowY = isMobile ? -400 : -600 * scale;
            const fastY = isMobile ? -700 : -1200 * scale;

            if (mobileBuckets.slow.length) {
                tl.to(mobileBuckets.slow,
                    { y: () => slowY, ease: "none", duration: scrollPinDistance },
                    0
                );
            }
            if (mobileBuckets.fast.length) {
                tl.to(mobileBuckets.fast,
                    { y: () => fastY, ease: "none", duration: scrollPinDistance },
                    0
                );
            }

            // Refresh ScrollTrigger to recalculate metrics after DOM stabilizes
            ScrollTrigger.refresh();
        });
    }

    initAnimations();

    // Watch for layout shifts from sections above (e.g. review-cards loading async content).
    // When their height changes, ScrollTrigger pin positions become stale.
    const reviewSection = document.querySelector('.section-review-cards, .review-cards__container');
    if (reviewSection) {
        let refreshTimer = null;
        const observer = new ResizeObserver(() => {
            // Debounce: wait for height to settle before refreshing
            clearTimeout(refreshTimer);
            refreshTimer = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 200);
        });
        observer.observe(reviewSection);
    }

    // Force refresh on window load in case images/fonts shift layout
    window.addEventListener('load', () => {
        ScrollTrigger.refresh();
    });
});
